var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "declaration-scope" }, [
    _c("div", { staticStyle: { display: "flex" } }, [
      _c(
        "div",
        {
          staticClass: "show-right section",
          staticStyle: { width: "60%", "background-color": "#FFFFFF" }
        },
        [
          _c(
            "div",
            {
              staticClass: "main-content left",
              staticStyle: { "margin-left": "20px", "margin-bottom": "50px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    disabled: _vm.useHqSet,
                    "label-width": "100px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "el-form-item-wrapper",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_DeclarationBusiness")
                              )
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "fcl", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.fcl,
                                  "fclArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.fcl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fcl", $$v)
                              },
                              expression: "form.fcl"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FCL")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              disabled: !(_vm.isEdit && _vm.form.fcl),
                              placeholder: " ",
                              filterable: "",
                              "static-options": _vm.eqSizeType,
                              "default-multiple-value": _vm.form.fclArray,
                              multiple: true,
                              cache: false,
                              "tag-name": "code",
                              "tag-value": "value",
                              "filter-tag-names": ["code"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.fclArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "selfPickup", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.selfPickup,
                                  "selfPickupArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.selfPickup,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "selfPickup", $$v)
                              },
                              expression: "form.selfPickup"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CustomerSpace3"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "selfPickupValue",
                              disabled: !(_vm.isEdit && _vm.form.selfPickup),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_IncoTerm,
                              filterable: "",
                              clearable: true,
                              "default-multiple-value":
                                _vm.form.selfPickupArray,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.selfPickupArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "designatedGoods",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.designatedGoods,
                                  "designatedGoodsArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.designatedGoods,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "designatedGoods", $$v)
                              },
                              expression: "form.designatedGoods"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CustomerSpace2"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "designatedGoodsValue",
                              disabled: !(
                                _vm.isEdit && _vm.form.designatedGoods
                              ),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_IncoTerm,
                              filterable: "",
                              clearable: true,
                              "default-multiple-value":
                                _vm.form.designatedGoodsArray,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.designatedGoodsArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "pol", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.pol,
                                  "loadingPortCodeArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.pol,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "pol", $$v)
                              },
                              expression: "form.pol"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_PortOfLoading"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1", width: "350px" },
                            attrs: {
                              no: "loadingPortCode",
                              disabled: !(_vm.isEdit && _vm.form.pol),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-multiple-value":
                                _vm.form.loadingPortCodeArray,
                              "custom-label": function(item) {
                                return "" + item.code
                              },
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.loadingPortCodeArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "pod", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.pod,
                                  "dischargingPortCodeArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.pod,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "pod", $$v)
                              },
                              expression: "form.pod"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_PlaceOfDelivery"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "dischargingPortCode",
                              disabled: !(_vm.isEdit && _vm.form.pod),
                              placeholder: " ",
                              "static-options": _vm.pods,
                              filterable: "",
                              "default-multiple-value":
                                _vm.form.dischargingPortCodeArray,
                              multiple: true,
                              "tag-name": "code",
                              "tag-value": "value",
                              "custom-label": function(item) {
                                return "" + item.code
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.dischargingPortCodeArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "ri", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.customJob,
                                  "customJobTypeArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.customJob,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customJob", $$v)
                              },
                              expression: "form.customJob"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CustomJobType"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "customJobType",
                              disabled: !(_vm.isEdit && _vm.form.customJob),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              "method-params": { active: true },
                              clearable: true,
                              filterable: "",
                              "default-multiple-value":
                                _vm.form.customJobTypeArray,
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.code +
                                  "]" +
                                  (_vm.isZh ? item.name : item.englishName) +
                                  "[" +
                                  item.type +
                                  "]" +
                                  item.containerLoadType
                                )
                              },
                              "tag-value": "uuid",
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customJobTypeArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "ri", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.cargoType,
                                  "cargoTypeArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoType", $$v)
                              },
                              expression: "form.cargoType"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CargoType")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "cargoType",
                              disabled: !(_vm.isEdit && _vm.form.cargoType),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoType,
                              "method-params": { sea: true },
                              clearable: true,
                              filterable: "",
                              "default-multiple-value": _vm.form.cargoTypeArray,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.cargoTypeArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-form-item-wrapper",
                      staticStyle: { "margin-top": "20px" }
                    },
                    [
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_DeclarationFee"))
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "price", disabled: true },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.price,
                                  "priceArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.price,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "price", $$v)
                              },
                              expression: "form.price"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FreightRate")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              filterable: "",
                              no: "price",
                              disabled: !(_vm.isEdit && _vm.form.price),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              clearable: true,
                              "default-multiple-value": _vm.form.priceArray,
                              multiple: true,
                              "callback-method-type": "value",
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.chargecode +
                                  "]" +
                                  (_vm.isZh ? item.zhName : item.enName)
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.priceArray = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticStyle: { "margin-left": "20px" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_LowerLimit") +
                                  " = " +
                                  _vm.$t("CargoMsg.Cargo_FreightRate")
                              ) +
                              " "
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "50px",
                                margin: "0 5px 0 5px"
                              },
                              attrs: {
                                disabled: !_vm.isEdit,
                                no: "lowerOperators",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.form.lowerOperators,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "lowerOperators", $$v)
                                },
                                expression: "form.lowerOperators"
                              }
                            },
                            _vm._l(_vm.numOperators, function(value) {
                              return _c("el-option", {
                                key: value,
                                attrs: { label: value, value: value }
                              })
                            }),
                            1
                          ),
                          _c("el-input-number", {
                            staticStyle: { width: "70px" },
                            attrs: {
                              disabled: !_vm.isEdit,
                              controls: false,
                              precision: 0,
                              min: 0,
                              max: 999999999
                            },
                            model: {
                              value: _vm.form.lowerNum,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "lowerNum", $$v)
                              },
                              expression: "form.lowerNum"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticStyle: { "margin-left": "20px" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_UpperLimit") +
                                  " = " +
                                  _vm.$t("CargoMsg.Cargo_FreightRate")
                              ) +
                              " "
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "50px",
                                margin: "0 5px 0 5px"
                              },
                              attrs: {
                                disabled: !_vm.isEdit,
                                no: "upperOperators",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.form.upperOperators,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "upperOperators", $$v)
                                },
                                expression: "form.upperOperators"
                              }
                            },
                            _vm._l(_vm.numOperators, function(value) {
                              return _c("el-option", {
                                key: value,
                                attrs: { label: value, value: value }
                              })
                            }),
                            1
                          ),
                          _c("el-input-number", {
                            staticStyle: { width: "70px" },
                            attrs: {
                              disabled: !_vm.isEdit,
                              controls: false,
                              precision: 0,
                              min: 0,
                              max: 999999999
                            },
                            model: {
                              value: _vm.form.upperNum,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "upperNum", $$v)
                              },
                              expression: "form.upperNum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "commission", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.commission,
                                  "commissionArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.commission,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "commission", $$v)
                              },
                              expression: "form.commission"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Commission")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              filterable: "",
                              no: "commissionArray",
                              disabled: !(_vm.isEdit && _vm.form.commission),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              clearable: true,
                              "default-multiple-value":
                                _vm.form.commissionArray,
                              multiple: true,
                              "callback-method-type": "value",
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.chargecode +
                                  "]" +
                                  (_vm.isZh ? item.zhName : item.enName)
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.commissionArray = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "containerLock",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.containerLock,
                                  "containerLockArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.containerLock,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "containerLock", $$v)
                              },
                              expression: "form.containerLock"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_ContainerLock"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              filterable: "",
                              no: "containerLockArray",
                              disabled: !(_vm.isEdit && _vm.form.containerLock),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              clearable: true,
                              "default-multiple-value":
                                _vm.form.containerLockArray,
                              multiple: true,
                              "callback-method-type": "value",
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.chargecode +
                                  "]" +
                                  (_vm.isZh ? item.zhName : item.enName)
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.containerLockArray = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "baf", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.baf,
                                  "bafArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.baf,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "baf", $$v)
                              },
                              expression: "form.baf"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v("BAF")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              filterable: "",
                              no: "bafArray",
                              disabled: !(_vm.isEdit && _vm.form.baf),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              clearable: true,
                              "default-multiple-value": _vm.form.bafArray,
                              multiple: true,
                              "callback-method-type": "value",
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.chargecode +
                                  "]" +
                                  (_vm.isZh ? item.zhName : item.enName)
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.bafArray = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "caf", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.caf,
                                  "cafArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.caf,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "caf", $$v)
                              },
                              expression: "form.caf"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v("CAF")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              filterable: "",
                              no: "cafArray",
                              disabled: !(_vm.isEdit && _vm.form.caf),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              clearable: true,
                              "default-multiple-value": _vm.form.cafArray,
                              multiple: true,
                              "callback-method-type": "value",
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.chargecode +
                                  "]" +
                                  (_vm.isZh ? item.zhName : item.enName)
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.cafArray = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "otherCharge", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.otherCharge,
                                  "otherChargeArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.otherCharge,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "otherCharge", $$v)
                              },
                              expression: "form.otherCharge"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_OtherAdditionalCharges")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              filterable: "",
                              no: "otherChargeArray",
                              disabled: !(_vm.isEdit && _vm.form.otherCharge),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              clearable: true,
                              "default-multiple-value":
                                _vm.form.otherChargeArray,
                              multiple: true,
                              "callback-method-type": "value",
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.chargecode +
                                  "]" +
                                  (_vm.isZh ? item.zhName : item.enName)
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.otherChargeArray = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "othc", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.othc,
                                  "othcArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.othc,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "othc", $$v)
                              },
                              expression: "form.othc"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v("O.THC")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              filterable: "",
                              no: "othcArray",
                              disabled: !(_vm.isEdit && _vm.form.othc),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              clearable: true,
                              "default-multiple-value": _vm.form.othcArray,
                              multiple: true,
                              "callback-method-type": "value",
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.chargecode +
                                  "]" +
                                  (_vm.isZh ? item.zhName : item.enName)
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.othcArray = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "dthc", disabled: !_vm.isEdit },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.dthc,
                                  "dthcArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.dthc,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dthc", $$v)
                              },
                              expression: "form.dthc"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v("D.THC")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              filterable: "",
                              no: "dthcArray",
                              disabled: !(_vm.isEdit && _vm.form.dthc),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              clearable: true,
                              "default-multiple-value": _vm.form.dthcArray,
                              multiple: true,
                              "callback-method-type": "value",
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.chargecode +
                                  "]" +
                                  (_vm.isZh ? item.zhName : item.enName)
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.dthcArray = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }